// extracted by mini-css-extract-plugin
module.exports = {"containerLogin":"Login_containerLogin__2GdzF","imgLogo":"Login_imgLogo__2F3x7"};